module.exports = __webpack_public_path__ + "static/media/Rita Cornwell (2).f627b717.JPG";